"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const React = __importStar(require("react"));
const SvgThumbNeutral = (props) => (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, fill: "none" }, props),
    React.createElement("path", { stroke: "#fff", strokeLinecap: "round", strokeLinejoin: "round", strokeOpacity: 0.48, strokeWidth: 2, d: "M18.598 3.822a6.51 6.51 0 0 0-6.336 0" }),
    React.createElement("path", { fill: "#fff", fillRule: "evenodd", d: "M18.425 8c-2.153 0-4.241.733-5.922 2.077l-4.12 3.291v2.28c.22 0 .44-.071.625-.218l4.743-3.79A7.5 7.5 0 0 1 18.426 10h9.747A1.83 1.83 0 0 1 30 11.824a1.823 1.823 0 0 1-1.827 1.824h-7.067q-.05 0-.1.005a3.64 3.64 0 0 0-1.827.423l-4.24 2.538a1 1 0 1 0 1.027 1.716l4.205-2.517a1.64 1.64 0 0 1 2.073.565 1.636 1.636 0 0 1-.562 2.334l-3.23 2.152a7.5 7.5 0 0 1-4.156 1.256H8.384v2h5.91v-1 1a9.5 9.5 0 0 0 5.266-1.591l3.212-2.14a3.64 3.64 0 0 0 1.356-4.74h4.044A3.83 3.83 0 0 0 32 11.823 3.823 3.823 0 0 0 28.172 8zm.026 12.864.55.825zm3.792-4.486.831-.556zm-2.073-.565-.028.014-.45-.893.513.858z", clipRule: "evenodd" }),
    React.createElement("rect", { width: 6.381, height: 15.375, y: 10.2, fill: "#fff", fillOpacity: 0.48, rx: 1 })));
exports.default = SvgThumbNeutral;
